var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/object-is-prototype-of.js
// module id = 21
// module chunks = 0 1